import { accountsUrl } from '../configs/environments';
import { AppExperiments, useExperiments, useIsTreatment } from '../utils/experiments';
import { useKillSwitch } from '../utils/killSwitches/useKillSwitch';

export const workspaceTeamRedirectUrl = `${accountsUrl}/organization-team`;

export function useShouldRedirectWorkspaceTeam(): boolean {
  const isExperimentTreatment = useIsTreatment(AppExperiments.t0018_99ac577d);
  const { isLoaded } = useExperiments();
  const forceRedirect = useKillSwitch('t0018_8e42f55c');

  return forceRedirect || (isLoaded && !isExperimentTreatment);
}
